module.exports = __webpack_public_path__ + "img/hammer-war.3af59be1.svg";